import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './ScrollToTop.css';
import React from 'react';
import debounce from 'lodash.debounce';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
//import IconArrowRight from '../../resources/icons/IconArrowRight.svg';
import { tealiumClickFunc } from '../../utils/tealium';
import { canUseDOM, get, getGlobalDictionaryTerm } from '../../utils';
import IconArrowRight from '../../components/atoms/Icons/IconArrowRight';
var ScrollToTop = function ScrollToTop(_ref) {
  var _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 100 : _ref$offset,
    analytics = _ref.analytics;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var toTopLabel = getGlobalDictionaryTerm(sitecoreContext, 'toTopLabel') || "To top";
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visible = _React$useState2[0],
    setVisibility = _React$useState2[1];
  React.useEffect(function () {
    if (typeof window === undefined) return;
    if (canUseDOM) {
      var html = document.scrollingElement || document.documentElement;
      html.style.scrollBehavior = 'smooth';
    }
  }, []);
  var handleScroll = React.useCallback(debounce(function () {
    if (canUseDOM) {
      var html = document.scrollingElement || document.documentElement;
      if (!html) return;
      if (html.scrollTop > offset && !visible) setVisibility(true);
      if (!html.scrollTop && visible) setVisibility(false);
    }
  }, 100, {
    leading: false,
    trailing: true
  }), [visible]);
  React.useEffect(function () {
    if (typeof window === undefined) return;
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
      handleScroll.cancel();
    };
  }, [handleScroll]);
  var handleButtonClick = React.useCallback(function () {
    if (canUseDOM) {
      var html = document.scrollingElement || document.documentElement;
      if (html) html.scrollTop = 0;
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: "my-icon-white back-to-top ".concat(visible ? 'visible' : '', " ").concat(disableInPrint),
    onClick: function onClick() {
      tealiumClickFunc(get(analytics, 'goToTopAnalytics', {}), 'Scroll Up');
      handleButtonClick();
    },
    textLabel: toTopLabel
  }, /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon back-to-top__icon"
  }));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className,
    onClick = _ref2.onClick,
    textLabel = _ref2.textLabel;
  return /*#__PURE__*/React.createElement("button", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className),
    onClick: onClick,
    tabIndex: 0,
    "aria-label": textLabel,
    title: textLabel
  }, children);
};
var disableInPrint = "d8axrx0";
var commonStyles = "c1v58enf";
var ltrStyles = "lytijta";
var rtlStyles = "rtef2i8";
export default ScrollToTop;